import { inject, InjectionToken } from '@angular/core';
import { STOREFRONT_LABELS_COOKIE, STOREFRONT_LABELS_QUERY_PARAM } from '../constants/storefront-labels.const';
import { resolveQueryCookieParam } from '../helpers/query-cookie-param/query-cookie-param.helper';
import { CookieFacade } from '../services/cookie/cookie.facade';
import { WINDOW } from './window';

/** Live resolver: call on each AGW request; do not treat inject result as a cached string. */
export type StorefrontLabelsResolver = () => string | null;

export const STOREFRONT_LABELS: InjectionToken<StorefrontLabelsResolver> = new InjectionToken<StorefrontLabelsResolver>(
  'Storefront Labels Token',
  {
    providedIn: 'root',
    factory: (): StorefrontLabelsResolver => {
      const window: Window = inject(WINDOW);
      const cookieFacade: CookieFacade = inject(CookieFacade);

      return (): string | null =>
        resolveQueryCookieParam({
          location: window.location,
          cookieFacade,
          queryParam: STOREFRONT_LABELS_QUERY_PARAM,
          cookieName: STOREFRONT_LABELS_COOKIE,
          hostname: window.location.hostname,
        });
    },
  }
);
